import { GetAdminSectionResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../services/core-api-service";

class AdminSectionService {
    public async getSection(sectionId: string): Promise<GetAdminSectionResult> {
        return api.admin.getSection(sectionId)
    }
}

export const service = new AdminSectionService()